<template>
  <div class="login container">
    <div v-if="!sellCardPermission()" class="pt-5">
      <h2>Sorry, you do not have permissions to access this feature.</h2>
    </div>
    <form v-else @submit.prevent="submit">
        <div class="row">
        <h1 class="col-md-12 pt-5">Success!</h1>
        </div>

        <div class="row" v-if="orderPayload.digitalJourney">
            <h2 class="col-md-12 pt-2">Digital card has been sent to {{orderPayload.email}}</h2>
        </div>

        <div class="row d-flex justify-content-center" v-if="orderPayload.physicalJourney">
          <div v-if="!orderPayload.unique_code">
            <h3>Transpose this code onto card</h3>
            <h2>{{orderPayload.card.card_reference.replace(/(\d{4})/g, '$1 ').replace(/(^\s+|\s+$)/,'')}}</h2>
            <h3>Transpose this PIN number onto card</h3>
            <h2>{{orderPayload.card.pin.replace(/(\d{3})/g, '$1 ').replace(/(^\s+|\s+$)/,'')}}</h2>
          </div>
        </div>

        <div class="row d-flex justify-content-center">
            <cta type="submit" text="Finish" :loading="submitted" />
        </div>
    </form>
   
  </div>
</template>

<script>
export default {
  name: 'Login',
  inject: ['$validator'],
  data : function(){       
      return {
          submitted     : false,
          receipt_email : ''
      };
  },
  created:function(){
  },
  computed: {

    orderPayload(){
      return this.$store.getters.getOrderPayload;
    },

  },
  watch:{

   
  },
  mounted: function(){

  },
  methods:{

    submit()
    {
        this.$store.commit("ORDER_PAYLOAD",{});
        this.$router.push({ name: 'home'});
    },

  }
}
</script>

<style scoped>

  .select-holder {
    margin-top: 15px;
  }

  h3 {
    font-size: 24px;
    margin: 40px 0 10px 0;
  }

  h2 {
    font-size: 30px;
    margin: 0;
  }
  
  @media only screen and (max-width: 550px) {
      h2 {
        font-size: 19px
      }
    }

  .cta-container {
    margin-top: 30px;
  }

</style>
